import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=63d39800&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=63d39800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d39800",
  null
  
)

export default component.exports